import { render, staticRenderFns } from "./TaizhangDialog.vue?vue&type=template&id=217c7c82&scoped=true"
import script from "./TaizhangDialog.vue?vue&type=script&lang=js"
export * from "./TaizhangDialog.vue?vue&type=script&lang=js"
import style0 from "./TaizhangDialog.vue?vue&type=style&index=0&id=217c7c82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_398719d9ba0fb65ce1cea3b2910bec76/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217c7c82",
  null
  
)

export default component.exports